<template>
  <div>
    <mobialis-form-with-validation @onValidate="continueForm">
      <div :class="{ 'row justify-content-between': showBlocks }">
        <div :class="{ 'col-sm-7': showBlocks }">
          <HelpUsVerify v-if="showBlocks"></HelpUsVerify>
          <!--
          <input hidden class="hidden" name="todays_date" value="currentDate" type="hidden">
          <input hidden class="hidden" name="earliest_date" value="earliestDate" type="hidden">
          TODO: Use previous hidden inputs to validate birthdate's earliest and latest possible dates
          -->
          <mobialis-text-input-with-validation
            :rules="birthDateValidationRule"
            :label="$t('message.credit.birthday')"
            v-model="birthdate"
            :helper="$t('message.credit.birthdayHelper')"
            vid="birthdate"
            mask-type="date"
            :raw="false"
            inputmode="numeric"
            data-cy="birthdate"
          ></mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            rules="required"
            :label="$t('message.credit.streetAddress')"
            v-model="streetAddress"
            vid="streetaddress"
            data-cy="streetAddress"
          ></mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            :label="$t('message.credit.unit#')"
            v-model="unitNumber"
            vid="unitNumber"
            data-cy="unitNumber"
          ></mobialis-text-input-with-validation>
          <mobialis-text-input-with-validation
            rules="required"
            :label="$t('message.common.city')"
            v-model="city"
            vid="city"
            data-cy="city"
          ></mobialis-text-input-with-validation>
          <mobialis-selection-input-with-validation
            rules="required"
            :label="$t('message.common.state')"
            v-model="state"
            vid="province"
            :placeHolder="$t('message.common.chooseState')"
            :options="states"
            data-cy="state"
          ></mobialis-selection-input-with-validation>
          <mobialis-text-input-with-validation
            v-if="!getFeatureList.creditPostalCodeFirstPage"
            rules="required|length:5"
            :label="$t('message.common.zipCode')"
            v-model="zipCode"
            vid="zipCode"
            data-cy="zipCode"
            mask-type="zipCode"
          ></mobialis-text-input-with-validation>
        </div>
        <div v-if="showBlocks" class="col-sm-4 d-none d-sm-block">
          <div class="card border-0 shadow mb-2" v-if="getBankStrips.length">
            <div>
              <BankStrip v-bind:creditForm="true" :company-list="getBankStrips" :logoSpacing="2"></BankStrip>
            </div>
          </div>
          <DisclaimerCard
            class="card border-0 shadow mb-2"
            :iconSrc="require('@/assets/eye.svg')"
            :title="$t('message.credit.creditform2CardTitle')"
            :text="$t('message.credit.creditform2CardText')"
            :text-left-space="false"
          ></DisclaimerCard>
        </div>
      </div>
      <mobialis-button data-cy="submitForm2" type="submit" class="mt-4 mb-1">{{
        $t('message.common.continue')
      }}</mobialis-button>
      <p class="d-flex justify-content-center small my-0">{{ $t('message.credit.disclaimer.noAffectScore') }}</p>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import log from '@/services/log';
import { stateMixin, formMixin } from '@/mixins';
import HelpUsVerify from '@/components/credit/hero/HelpUsVerify.vue';
import DisclaimerCard from '@/components/DisclaimerCard.vue';
import BankStrip from '@/components/BankStrip.vue';

export default {
  name: 'CreditForm2US',
  mixins: [stateMixin, formMixin],
  data() {
    return {
      birthdate: '',
      streetAddress: '',
      unitNumber: '',
      city: '',
      state: '',
      zipCode: '',
    };
  },
  components: {
    DisclaimerCard,
    HelpUsVerify,
    BankStrip,
  },
  computed: {
    ...mapGetters('business', ['getBankStrips', 'getFeatureList']),
  },
  mounted() {
    this.birthdate = this.$store.state.user.birthdate;
    this.streetAddress = this.$store.state.user.streetAddress;
    this.unitNumber = this.$store.state.user.unit;
    this.city = this.$store.state.user.city;
    this.state = this.$store.state.user.state;
    this.zipCode = this.$store.state.user.zipCode;
  },
  methods: {
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }
      try {
        this.$store.commit('user/SET_BIRTHDATE', this.birthdate);
        this.$store.commit('user/SET_STREET_ADDRESS', this.streetAddress);
        this.$store.commit('user/SET_UNIT', this.unitNumber);
        this.$store.commit('user/SET_CITY', this.city);
        this.$store.commit('user/SET_STATE', this.state);
        this.$store.commit('user/SET_ZIP_CODE', this.zipCode);
        await this.$store.dispatch('lead/updateLead');
      } catch (err) {
        log('Error in Creditform 2 US - Update Lead', err);
        this.$router.push({ name: `credit-in-error-${this.baseRoute}` });
      }
      this.$router.push('form-review');
    },
  },
};
</script>

<style lang="scss" scoped>
.small {
  font-size: 12px;
  color: rgb(25, 34, 43);
}
</style>
